/**
 * Profile Preferences Page (Web)
 * Placeholder for Profile Preferences
 */

import { Fragment } from 'react';
import { AuthenticatedLayout } from '../../components/layout/AuthenticatedLayout';

export function ProfilePreferencesPage() {
  return (
    <AuthenticatedLayout>
      <Fragment />
    </AuthenticatedLayout>
  );
}

